import React, { PureComponent, Fragment } from "react";
import SelectItem from "react-select";
const styles = {
  option: (styles, state) => ({
    ...styles,
    borderBottom: "#79b340",
    backgroundColor: state.isSelected ? "#79b340" : ""
  })
};
class Select extends PureComponent {
  constructor(props) {
    super(props);
    props = this.props;
    this.state = {
      item_default: props.item_default || [], // Item default
      multiple: props.multiple || false, // Indica si es simple o seleccion mÃºltiple
      placeholder: props.placeholder || "Select", // Etiqueta Placeholder
      store: props.store || [], // Store data [label:,value:]
      nullable: props.nullable || true, // No permite seleccion vacia, por defecto selecciona el default
      item_all: props.item_all || false,
      item_selected: props.item_default || []
    };
  }
  handleChange = event => {
    const me = this,
      props = me.props;
    if (event === null) {
      event = [];
    }
    let items = [];
    if (me.state.multiple) {
      if (event.length > 0) {
        event.forEach(function(item) {
          if (me.state.item_all) {
            if (item.value !== me.state.item_default[0].value) {
              items.push(item);
            }
          } else {
            items.push(item);
          }
        });
      } else {
        if (this.state.nullable) {
          items = me.state.item_default;
        }
      }
    } else {
      items = [event];
    }
    this.setState({ item_selected: items });
    let scope = props.scope || this;
    if (props.onChange) {
      props.onChange.call(scope, items);
    }
  };
  render() {
    let { multiple, placeholder, store, item_selected } = this.state;
    if (this.props.store.length !== this.state.store.length) {
      store = this.props.store;
    }
    return (
      <Fragment>
        <SelectItem
        styles={styles}
          isMulti={multiple}
          placeholder={placeholder}
          onChange={this.handleChange}
          value={item_selected}
          options={store}
          theme={theme => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: "#008BD2"
            }
          })}
        />
      </Fragment>
    );
  }
}

export default Select;
